const cacheMajorVersion = "8";
export const OfflineConstants = {
  cacheMajorVersion: cacheMajorVersion,
  tableOfContentsCacheName: "tocCache",
  songsheetfilesCacheName: "songsheetCache",
  prefix: "songship",
  suffix: `v${cacheMajorVersion}`,
} as const;
